/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overwriteContainer[_ngcontent-%COMP%]{padding:20px;text-align:center;overflow-y:auto}.confirm[_ngcontent-%COMP%]{background-color:#23be23;color:var(--text-color6);margin-right:10px}.cancel[_ngcontent-%COMP%]{background-color:#e63c3c;color:var(--text-color6)}.controls[_ngcontent-%COMP%]{width:100%;margin-top:10px}"];
export { styles as styles };
